import { Navigation } from '@angular/router';

export function isSamePageOutletNavigation(navigation: Navigation, outletName: string): boolean {
    const navigationRootChildrenAvailable = !!navigation.finalUrl?.root.children?.primary;
    if (!navigationRootChildrenAvailable) {
        return false;
    }

    // Navigates to 'preview' outlet
    const navigatedToPreviewModal = !!navigation.finalUrl?.root.children?.primary.children?.preview;

    // Navigates from 'preview' outlet
    const navigatedFromPreviewModal =
        !!navigation.previousNavigation?.finalUrl?.root.children?.primary.children?.preview;

    return navigatedToPreviewModal || navigatedFromPreviewModal;
}
